export enum SandboxLogLevel {
  debug = 'DEBUG',
  error = 'ERROR',
  info = 'INFO',
  warn = 'WARN'
}
